import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store/store';
import {
  clearVignettes,
  setVignettes,
  setVignettesForBlock,
} from '../vignettes/vignettesSlice';

export enum StudyPhase {
  HOME = 'home',
  BLOCK_STUDY = 'blockStudy',
  BLOCK_REVIEW = 'blockReview',
  FLASHCARD_STUDY = 'flashcardStudy',
  SESSION_SUMMARY = 'sessionSummary',
  VIDEO_STUDY = 'videoStudy',
}

interface StudyState {
  phase: StudyPhase;
  activeQuestionIndex: number;
  activeQuestionBlockId: string | null;
}

const initialState: StudyState = {
  phase: StudyPhase.HOME,
  activeQuestionIndex: 0,
  activeQuestionBlockId: null,
};

const studySlice = createSlice({
  name: 'studyPhase',
  initialState,
  reducers: {
    setStudyPhase(state, action: PayloadAction<StudyPhase>) {
      state.phase = action.payload;
    },
    setActiveQuestionIndex(state, action: PayloadAction<number>) {
      state.activeQuestionIndex = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setVignettesForBlock, (state, action) => {
        // Keep resume behavior when reloading the same block, but reset if block changes.
        if (state.activeQuestionBlockId !== action.payload.blockId) {
          state.activeQuestionIndex = 0;
        }
        state.activeQuestionBlockId = action.payload.blockId;
      })
      .addCase(setVignettes, (state) => {
        state.activeQuestionIndex = 0;
        state.activeQuestionBlockId = null;
      })
      .addCase(clearVignettes, (state) => {
        state.activeQuestionIndex = 0;
        state.activeQuestionBlockId = null;
      });
  },
});

export const selectStudyPhase = (state: RootState) => state.studyPhase.phase;
export const selectActiveQuestionIndex = (state: RootState) =>
  state.studyPhase.activeQuestionIndex;

export const { setStudyPhase, setActiveQuestionIndex } = studySlice.actions;
export default studySlice.reducer;
